import QuestionLayout from "./QuestionLayout";

function normalizeLetter(input) {
  if (!input) return "";
  return input.trim().toUpperCase();
}

export default function FifthLetterWidget({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  function updatePart(id, nextValue) {
    onChange({
      ...value,
      [id]: normalizeLetter(nextValue)
    });
  }

  function partFeedback(id) {
    return feedback?.parts?.[id] ?? null;
  }

  function inputBorder(id) {
    const fb = partFeedback(id);

    if (mode === "review") {
      return fb?.correct ? "2px solid #2e7d32" : "2px solid #c62828";
    }

    return "1px solid #aaa";
  }

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "120px 80px 120px",
          alignItems: "center",
          justifyContent: "center",
          columnGap: 26,
          marginTop: 10
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0
          }}
        >
          <input
            type="text"
            maxLength={1}
            value={value.down || ""}
            disabled={mode !== "edit"}
            onChange={(e) => updatePart("down", e.target.value)}
            style={{
              width: 80,
              height: 38,
              fontSize: 22,
              textAlign: "center",
              textTransform: "uppercase",
              borderRadius: 6,
              border: inputBorder("down")
            }}
          />

          <div style={{ fontSize: 14 }}>down a 5th</div>
        </div>

        <div
          style={{
            position: "relative",
            width: 80,
            height: 80,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <svg
            width="160"
            height="50"
            viewBox="0 0 160 50"
            style={{
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              overflow: "visible",
              pointerEvents: "none"
            }}
          >
            <defs>
              <marker
                id="arrowhead-left"
                markerWidth="8"
                markerHeight="8"
                refX="2"
                refY="4"
                orient="auto"
              >
                <path d="M8,0 L0,4 L8,8 Z" fill="#000" />
              </marker>

              <marker
                id="arrowhead-right"
                markerWidth="8"
                markerHeight="8"
                refX="6"
                refY="4"
                orient="auto"
              >
                <path d="M0,0 L8,4 L0,8 Z" fill="#000" />
              </marker>
            </defs>

            <line
              x1="12"
              y1="25"
              x2="70"
              y2="25"
              stroke="#000"
              strokeWidth="2"
              markerStart="url(#arrowhead-left)"
            />

            <line
              x1="90"
              y1="25"
              x2="148"
              y2="25"
              stroke="#000"
              strokeWidth="2"
              markerEnd="url(#arrowhead-right)"
            />
          </svg>

          <div
            style={{
              position: "relative",
              zIndex: 1,
              fontSize: 42,
              fontWeight: "bold",
              lineHeight: 1,
              background: "white",
              padding: "0 8px"
            }}
          >
            {config.centerLetter || "C"}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0
          }}
        >
          <input
            type="text"
            maxLength={1}
            value={value.up || ""}
            disabled={mode !== "edit"}
            onChange={(e) => updatePart("up", e.target.value)}
            style={{
              width: 80,
              height: 38,
              fontSize: 22,
              textAlign: "center",
              textTransform: "uppercase",
              borderRadius: 6,
              border: inputBorder("up")
            }}
          />

          <div style={{ fontSize: 14 }}>up a 5th</div>
        </div>
      </div>
    </QuestionLayout>
  );
}